/**
 * Cross-sell "Complete the ritual" add-to-cart. Mirrors the theme's own product
 * form flow: /cart/add.js -> /cart.js -> cartUpdate pubsub -> cart drawer opens.
 * Variant ids are read from server-rendered data attributes, never hardcoded.
 */
(function () {
  'use strict';

  var adding = false;

  function routes() {
    return (window.theme && theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };
  }

  function addToCart(items) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    var r = routes();
    return fetch(r.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (parsed) {
          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || 'Could not add to cart.');
          }
          return parsed;
        });
      })
      .then(function (parsed) {
        return fetch(r.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            cart.sections = parsed.sections;
            if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cart });
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            }
          });
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fudge-xr-add]');
    if (!btn) return;
    if (adding || btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    adding = true;
    btn.classList.add('is-adding');
    btn.setAttribute('aria-disabled', 'true');

    addToCart([{ id: variantId, quantity: 1 }])
      .catch(function (err) {
        alert(err && err.message ? err.message : 'Could not add to cart. Please try again.');
      })
      .then(function () {
        btn.classList.remove('is-adding');
        btn.removeAttribute('aria-disabled');
        adding = false;
      });
  });
})();
